export default "__VITE_ASSET__Cz2uxEw___"